import { useEffect, useState } from 'preact/hooks'

function useForceUpdateOnResize() {
  const [state, setState] = useState(false)

  useEffect(() => {
    const cb = () => setState(s => !s)
    window.addEventListener('resize', cb)

    return () => {
      window.removeEventListener('resize', cb)
    }
  }, [])

  return state
}

export default useForceUpdateOnResize
